export const FILTER_TYPE = {
  HEADER: 'header'
};
